import { getEnvironment } from '@/lib/environment'
import { IS_CN_SITE } from '@/config/site'

// CN site: visible in all environments. AI site: visible only outside prod.
export const SHOW_ARENA_ENTRY = IS_CN_SITE || getEnvironment() !== 'prod';

export const ENABLE_VIDEO_MOTION_TRANSFER = false;

export const ENABLE_IMAGE_PORTRAIT_ENHANCE = true;

export const ENABLE_IMAGE_EMOTION_ADJUSTMENT = true;

// Phone authentication and binding are always available on the CN site.
// Other sites expose them only outside production for development and testing.
export const ENABLE_PHONE_AUTH = IS_CN_SITE || getEnvironment() !== 'prod';
export const ENABLE_PHONE_BINDING = ENABLE_PHONE_AUTH;

export function isCanvasMediaAnalysisEnabled(hostname?: string): boolean {
  void hostname;
  return true;
}

export function isDevEnvironment(): boolean {
  const env = getEnvironment(hostnameOrUndefined())
  return env === 'localhost' || env === 'dev'
}

function hostnameOrUndefined(): string | undefined {
  return typeof window === 'undefined' ? undefined : window.location.hostname;
}

export const INCOMPLETE_NODE_TYPES = ['3dWorld'] as const
export const INCOMPLETE_ACADEMY_SLUGS = ['3d-world'] as const
